import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './search_type_selector.module.scss';
import { CustomDropdown } from '../../../../components/custom-dropdown/CustomDropdown';
import { DesktopType } from '../../type-selector-dropdown/DesktopType';
import { searchConstants } from '../../../search-utils/searchConstants';
import { Connect, PropsFromRedux } from './SearchTypeSelectorContainer';
import { reportFilterToggle } from '../../mobile-actions/filtersUtils';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { StateType } from '../../../../state/reducers';
import { TextButton } from '../../../../components/button';

type Props = PropsFromRedux;

const RawSearchTypeSelector: FC<Props> = ({ selected, updateCounts }) => {
  const { types } = searchConstants;
  const type = types.find(({ key }) => key === selected);

  const onToggle = (toggle: Function) => {
    return () => {
      reportFilterToggle(selected, 'content_type', true);
      updateCounts();
      toggle();
    };
  };

  const onSelect = (toggle: Function) => {
    return (selectedType: keyof StateType['results']['counts']) => {
      doctrineAnalytics('Search FilterContentTypeClicked', {
        type: selectedType,
      });
      toggle();
    };
  };

  return (
    <CustomDropdown className={styles.container}>
      {(isOpen, toggle) => (
        <div className={styles.wrapper}>
          <TextButton onClick={onToggle(toggle)} iconRight="expand_more">
            {type && <FormattedMessage id={type.labelId} />}
          </TextButton>
          {isOpen && (
            <div className={styles.dropdown}>
              <DesktopType onClick={onSelect(toggle)} />
            </div>
          )}
        </div>
      )}
    </CustomDropdown>
  );
};

export const SearchTypeSelector = Connect(RawSearchTypeSelector);
